module.exports = "<section *ngIf=\"post$ | async as post\">\n  <h1>{{ post.title }}</h1>\n  <div>{{ post.body }}</div>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main